<template>
  <div class="title">
    <span>{{ title }}</span>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: () => "",
    },
  },
};
</script>

<style lang="less" scoped>
.title {
  padding: 24px 0;
  width: 100%;
  text-align: center;

  span {
    position: relative;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 28px;
    color: #333333;
    line-height: 40px;

    &:before,
    &:after {
      content: "";
      position: absolute;
      width: 88px;
      height: 1px;
      background: #E2E4EA;
      top: 21px;
    }

    &:before {
      left: -112px;
    }

    &:after {
      right: -112px;
    }
  }
}
</style>
